import { Injectable } from '@angular/core';
import { PrognosisCostsItemLineDto } from '../models/prognosis/prognosis-costs-item-line-dto.model';
import { YearAmountAndNumberService } from './year-amount-and-number.service';

@Injectable({ providedIn: 'root' })
export class PrognosisCostsItemLineService {
  //#region Constructor
  constructor(
    private readonly _yearAmountAndNumberService: YearAmountAndNumberService
  ) { }
  //#endregion

  //#region Public methods
  public create(year: number): PrognosisCostsItemLineDto {
    return {
      id: undefined,
      name: undefined,
      budget: this._yearAmountAndNumberService.create(undefined, undefined),
      prognosis: this._yearAmountAndNumberService.create(year, undefined)
    };
  }
  //#endregion
}
